import { CustomersTable } from "@/services/backend/customers/components/customers-table";
import { NavLink, Outlet } from "react-router";
import { ReactNode, useCallback } from "react";
import { MainPageContent } from "@/routes/_components/main-page";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";

export function CustomersRoute() {
  const canAccess = useFeatureAuth("gsm.processes.process.close");
  if (!canAccess) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  return <Outlet />;
}

export function CustomersIndexRoute() {
  const showCreateCustomerButton = useFeatureAuth(
    "gsm.customers.customer.create",
  );

  const renderRowLink = useCallback(
    (customerId: string, children: ReactNode) => (
      <NavLink to={`/customers/${customerId}/address`}>{children}</NavLink>
    ),
    [],
  );

  return (
    <MainPageContent>
      <CustomersTable
        renderRowLink={renderRowLink}
        showCreateCustomerButton={showCreateCustomerButton}
      />
    </MainPageContent>
  );
}
